import * as PIXI from 'pixi.js';
import Element from '../../Prototype/UI/Element';
import UIComponent from './UIComponent';

export default class UIScrollComponent extends UIComponent {
    public UIComponent: PIXI.ui.component.Scroll;

    public attach(gameObject: Element, params: any): void {
        this.UIComponent = new PIXI.ui.component.Scroll(
            params.data.direction,
            params.data.friction,
            params.data.scrollWidth,
            params.data.scrollHeight,
        );

        gameObject.container.add(this.UIComponent);

        super.attach(gameObject, params);
    }
}
